/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as WaitingImport } from './routes/waiting';
import { Route as RulesImport } from './routes/rules';
import { Route as ResetPasswordImport } from './routes/reset-password';
import { Route as RegisterImport } from './routes/register';
import { Route as ProtectedImport } from './routes/protected';
import { Route as PrivacyImport } from './routes/privacy';
import { Route as NotProtectedImport } from './routes/not-protected';
import { Route as LoginImport } from './routes/login';
import { Route as ForgotPasswordImport } from './routes/forgot-password';
import { Route as EnterCodeImport } from './routes/enter-code';
import { Route as EmailVerifiedImport } from './routes/email-verified';
import { Route as ChallengesImport } from './routes/challenges';
import { Route as IndexImport } from './routes/index';
import { Route as ChallengeIdImport } from './routes/challenge.$id';

// Create/Update Routes

const WaitingRoute = WaitingImport.update({
  id: '/waiting',
  path: '/waiting',
  getParentRoute: () => rootRoute,
} as any);

const RulesRoute = RulesImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRoute,
} as any);

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any);

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any);

const ProtectedRoute = ProtectedImport.update({
  id: '/protected',
  path: '/protected',
  getParentRoute: () => rootRoute,
} as any);

const PrivacyRoute = PrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any);

const NotProtectedRoute = NotProtectedImport.update({
  id: '/not-protected',
  path: '/not-protected',
  getParentRoute: () => rootRoute,
} as any);

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any);

const EnterCodeRoute = EnterCodeImport.update({
  id: '/enter-code',
  path: '/enter-code',
  getParentRoute: () => rootRoute,
} as any);

const EmailVerifiedRoute = EmailVerifiedImport.update({
  id: '/email-verified',
  path: '/email-verified',
  getParentRoute: () => rootRoute,
} as any);

const ChallengesRoute = ChallengesImport.update({
  id: '/challenges',
  path: '/challenges',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const ChallengeIdRoute = ChallengeIdImport.update({
  id: '/challenge/$id',
  path: '/challenge/$id',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/challenges': {
      id: '/challenges';
      path: '/challenges';
      fullPath: '/challenges';
      preLoaderRoute: typeof ChallengesImport;
      parentRoute: typeof rootRoute;
    };
    '/email-verified': {
      id: '/email-verified';
      path: '/email-verified';
      fullPath: '/email-verified';
      preLoaderRoute: typeof EmailVerifiedImport;
      parentRoute: typeof rootRoute;
    };
    '/enter-code': {
      id: '/enter-code';
      path: '/enter-code';
      fullPath: '/enter-code';
      preLoaderRoute: typeof EnterCodeImport;
      parentRoute: typeof rootRoute;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/not-protected': {
      id: '/not-protected';
      path: '/not-protected';
      fullPath: '/not-protected';
      preLoaderRoute: typeof NotProtectedImport;
      parentRoute: typeof rootRoute;
    };
    '/privacy': {
      id: '/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof PrivacyImport;
      parentRoute: typeof rootRoute;
    };
    '/protected': {
      id: '/protected';
      path: '/protected';
      fullPath: '/protected';
      preLoaderRoute: typeof ProtectedImport;
      parentRoute: typeof rootRoute;
    };
    '/register': {
      id: '/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof RegisterImport;
      parentRoute: typeof rootRoute;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordImport;
      parentRoute: typeof rootRoute;
    };
    '/rules': {
      id: '/rules';
      path: '/rules';
      fullPath: '/rules';
      preLoaderRoute: typeof RulesImport;
      parentRoute: typeof rootRoute;
    };
    '/waiting': {
      id: '/waiting';
      path: '/waiting';
      fullPath: '/waiting';
      preLoaderRoute: typeof WaitingImport;
      parentRoute: typeof rootRoute;
    };
    '/challenge/$id': {
      id: '/challenge/$id';
      path: '/challenge/$id';
      fullPath: '/challenge/$id';
      preLoaderRoute: typeof ChallengeIdImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/challenges': typeof ChallengesRoute;
  '/email-verified': typeof EmailVerifiedRoute;
  '/enter-code': typeof EnterCodeRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/not-protected': typeof NotProtectedRoute;
  '/privacy': typeof PrivacyRoute;
  '/protected': typeof ProtectedRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/rules': typeof RulesRoute;
  '/waiting': typeof WaitingRoute;
  '/challenge/$id': typeof ChallengeIdRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/challenges': typeof ChallengesRoute;
  '/email-verified': typeof EmailVerifiedRoute;
  '/enter-code': typeof EnterCodeRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/not-protected': typeof NotProtectedRoute;
  '/privacy': typeof PrivacyRoute;
  '/protected': typeof ProtectedRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/rules': typeof RulesRoute;
  '/waiting': typeof WaitingRoute;
  '/challenge/$id': typeof ChallengeIdRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/challenges': typeof ChallengesRoute;
  '/email-verified': typeof EmailVerifiedRoute;
  '/enter-code': typeof EnterCodeRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/not-protected': typeof NotProtectedRoute;
  '/privacy': typeof PrivacyRoute;
  '/protected': typeof ProtectedRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/rules': typeof RulesRoute;
  '/waiting': typeof WaitingRoute;
  '/challenge/$id': typeof ChallengeIdRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/challenges'
    | '/email-verified'
    | '/enter-code'
    | '/forgot-password'
    | '/login'
    | '/not-protected'
    | '/privacy'
    | '/protected'
    | '/register'
    | '/reset-password'
    | '/rules'
    | '/waiting'
    | '/challenge/$id';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/challenges'
    | '/email-verified'
    | '/enter-code'
    | '/forgot-password'
    | '/login'
    | '/not-protected'
    | '/privacy'
    | '/protected'
    | '/register'
    | '/reset-password'
    | '/rules'
    | '/waiting'
    | '/challenge/$id';
  id:
    | '__root__'
    | '/'
    | '/challenges'
    | '/email-verified'
    | '/enter-code'
    | '/forgot-password'
    | '/login'
    | '/not-protected'
    | '/privacy'
    | '/protected'
    | '/register'
    | '/reset-password'
    | '/rules'
    | '/waiting'
    | '/challenge/$id';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ChallengesRoute: typeof ChallengesRoute;
  EmailVerifiedRoute: typeof EmailVerifiedRoute;
  EnterCodeRoute: typeof EnterCodeRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  LoginRoute: typeof LoginRoute;
  NotProtectedRoute: typeof NotProtectedRoute;
  PrivacyRoute: typeof PrivacyRoute;
  ProtectedRoute: typeof ProtectedRoute;
  RegisterRoute: typeof RegisterRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  RulesRoute: typeof RulesRoute;
  WaitingRoute: typeof WaitingRoute;
  ChallengeIdRoute: typeof ChallengeIdRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChallengesRoute: ChallengesRoute,
  EmailVerifiedRoute: EmailVerifiedRoute,
  EnterCodeRoute: EnterCodeRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NotProtectedRoute: NotProtectedRoute,
  PrivacyRoute: PrivacyRoute,
  ProtectedRoute: ProtectedRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RulesRoute: RulesRoute,
  WaitingRoute: WaitingRoute,
  ChallengeIdRoute: ChallengeIdRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/challenges",
        "/email-verified",
        "/enter-code",
        "/forgot-password",
        "/login",
        "/not-protected",
        "/privacy",
        "/protected",
        "/register",
        "/reset-password",
        "/rules",
        "/waiting",
        "/challenge/$id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/challenges": {
      "filePath": "challenges.tsx"
    },
    "/email-verified": {
      "filePath": "email-verified.tsx"
    },
    "/enter-code": {
      "filePath": "enter-code.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/not-protected": {
      "filePath": "not-protected.tsx"
    },
    "/privacy": {
      "filePath": "privacy.tsx"
    },
    "/protected": {
      "filePath": "protected.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/rules": {
      "filePath": "rules.tsx"
    },
    "/waiting": {
      "filePath": "waiting.tsx"
    },
    "/challenge/$id": {
      "filePath": "challenge.$id.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
